module.exports = __webpack_public_path__ + "img/coor1.2e98705e.png";